import React, { useState, useEffect } from 'react';
import './App.css';
import InvitationPage from './InvitationPage';
import CRMDashboard from './components/CRM/CRMDashboard';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const AuthPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // Forced password change (admin-set temporary password)
  const [changeToken, setChangeToken] = useState(null);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 12) return setError('Le nouveau mot de passe doit contenir au moins 12 caractères.');
    if (newPassword !== confirmPassword) return setError('Les mots de passe ne correspondent pas.');
    try {
      const response = await fetch(`${API_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ change_token: changeToken, current_password: currentPassword, new_password: newPassword }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('token', data.token);
        onLogin(data.token);
      } else {
        if (response.status === 401) { setChangeToken(null); setCurrentPassword(''); }
        setError(data.error || 'Échec du changement de mot de passe');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Login only. Access is invitation-only — new accounts are created via the invite link
      // (/invite/:token → InvitationPage), not a public sign-up form.
      const endpoint = `${API_URL}/api/auth/login`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // carry the Cloudflare Access cookie once Access is enforced
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (response.ok && data.must_change_password) {
        setChangeToken(data.change_token);
        setCurrentPassword(password);
        setPassword('');
      } else if (response.ok) {
        localStorage.setItem('token', data.token);
        onLogin(data.token);
      } else {
        setError(data.error || "Échec de l'authentification");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/elephant-icon.svg" alt="ElephantC2" />
        </div>
        <h1>ElephantC2</h1>
        <p className="auth-tagline" style={{ fontStyle: 'normal' }}>Toujours en avant.</p>
        {changeToken ? (
          <form onSubmit={handleChangePassword}>
            <p style={{ fontSize: '0.9rem', color: '#334155', marginBottom: '0.75rem' }}>
              Vous utilisez un mot de passe temporaire. Choisissez un nouveau mot de passe pour continuer.
            </p>
            <input type="password" placeholder="Nouveau mot de passe (12 caractères min.)" value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" required />
            <input type="password" placeholder="Confirmer le mot de passe" value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)} autoComplete="new-password" required />
            <button type="submit">Changer le mot de passe</button>
          </form>
        ) : (
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Adresse courriel" value={email}
            onChange={(e) => setEmail(e.target.value)} required />
          <input type="password" placeholder="Mot de passe" value={password}
            onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit">Se connecter</button>
        </form>
        )}
        <p className="auth-toggle" style={{ fontSize: '0.85rem', color: '#64748B' }}>
          L'accès se fait sur invitation. Contactez le Quartier Général pour obtenir un compte.
        </p>
        {error && <p className="error">{error}</p>}
      </div>
    </div>
  );
};

const CRMApp = ({ onLogout }) => (
  <div className="app-container">
    <header className="app-header">
      <div className="header-left">
        <img src="/elephant-icon.svg" alt="ElephantC2" className="app-logo" />
        <div className="header-text">
          <h1>ElephantC2</h1>
          <p style={{ fontStyle: 'normal', fontSize: '1.3rem' }}>Toujours en avant.</p>
        </div>
      </div>
      <button className="logout-btn" onClick={onLogout}>Logout</button>
    </header>
    <main className="app-main">
      <CRMDashboard />
    </main>
  </div>
);

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [inviteToken, setInviteToken] = useState(null);

  useEffect(() => {
    const match = window.location.pathname.match(/\/invite\/(.+)/);
    if (match) setInviteToken(match[1]);
  }, []);

  const handleLogin = (newToken) => { setToken(newToken); setInviteToken(null); };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  if (inviteToken) return <InvitationPage token={inviteToken} onSuccess={handleLogin} />;

  return token
    ? <CRMApp onLogout={handleLogout} />
    : <AuthPage onLogin={handleLogin} />;
}
